"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _header = _interopRequireDefault(require("../header"));

var _DashboardTimezoneDisclaimer = require("./DashboardTimezoneDisclaimer");

var _utils = require("./utils");

var _CompanyIdeasTable = _interopRequireDefault(require("./CompanyDashboard/CompanyIdeasTable"));

var _axios = _interopRequireDefault(require("axios"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var CompanyDashboard = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(CompanyDashboard, _Component);

  var _super = _createSuper(CompanyDashboard);

  function CompanyDashboard() {
    var _this;

    (0, _classCallCheck2.default)(this, CompanyDashboard);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      isSalesforceIntegrationEnabled: false
    });
    return _this;
  }

  (0, _createClass2.default)(CompanyDashboard, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                (0, _utils.trackDashboardUsage)('company-dashboard');
                _context.next = 3;
                return this.isSalesforceIntegrationEnabled();

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "isSalesforceIntegrationEnabled",
    value: function () {
      var _isSalesforceIntegrationEnabled = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var _yield$axios$post, data;

        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _axios.default.post('/analyticsV2/isSalesforceIntegrationEnabled');

              case 2:
                _yield$axios$post = _context2.sent;
                data = _yield$axios$post.data;
                this.setState({
                  isSalesforceIntegrationEnabled: data.isSalesforceIntegrationEnabled
                });

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function isSalesforceIntegrationEnabled() {
        return _isSalesforceIntegrationEnabled.apply(this, arguments);
      }

      return isSalesforceIntegrationEnabled;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          company = _this$props.company,
          ideaStatuses = _this$props.ideaStatuses;
      var isSalesforceIntegrationEnabled = this.state.isSalesforceIntegrationEnabled;
      return (0, _preact.h)("div", {
        className: "company-dashboard-overview dashboard-overview"
      }, (0, _preact.h)(_header.default, {
        title: "".concat(company.name, " Dashboard"),
        disableCancelButton: true,
        disableSaveButton: true
      }), (0, _preact.h)("div", {
        className: "metric-container"
      }, (0, _preact.h)(_CompanyIdeasTable.default, {
        isSalesforceIntegrationEnabled: isSalesforceIntegrationEnabled,
        companyId: company.id,
        ideaStatuses: ideaStatuses
      })), (0, _preact.h)(_DashboardTimezoneDisclaimer.DashboardTimezoneDisclaimer, null));
    }
  }]);
  return CompanyDashboard;
}(_preact.Component);

var _default = CompanyDashboard;
exports.default = _default;